import { Injectable } from '@angular/core';
import {  HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { Loanapprovallevel } from "./loanapprovallevel.model";
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class LoanapprovallevelService {
  
  selectedLoanapprovallevel: Loanapprovallevel;
  loanSchemeList: Loanapprovallevel[];
  constructor(private httpClient: HttpClient) { }

  getBaseUrl() {

    return environment.baseUrl;
  }

  IUDLoanApprovalLevel(loanapprovallevel: Loanapprovallevel) {

    loanapprovallevel.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    loanapprovallevel.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    loanapprovallevel.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    loanapprovallevel.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = loanapprovallevel;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/LoanApprovalProcess/IUD', body, { headers: headers });
  }
  
  FetchLoanApprovalLevelList() {

    this.selectedLoanapprovallevel = new Loanapprovallevel();
    this.selectedLoanapprovallevel.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLoanapprovallevel.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLoanapprovallevel.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLoanapprovallevel.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = null;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/LoanApprovalProcess/FetchList', body, { headers: headers });
   }

  FetchLoanApprovalLevelById(loanapprovallevel) {

    loanapprovallevel.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    loanapprovallevel.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    loanapprovallevel.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    loanapprovallevel.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = loanapprovallevel;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/LoanApprovalProcess/Fetch', body, { headers: headers });
  }
  
  FetchLoanSchemeList() {

    this.selectedLoanapprovallevel = new Loanapprovallevel();
    this.selectedLoanapprovallevel.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLoanapprovallevel.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLoanapprovallevel.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLoanapprovallevel.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedLoanapprovallevel;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/LoanScheme/FetchList', body, { headers: headers });
  }

  FetchLoanType() {
    let body = '';
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/LoanType', body, { headers: headers });
  }

  FetchLoanCategory() {
    let body = '';
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/LoanCategory', body, { headers: headers });
  }

  FetchPeriodType(){
    let body = '';
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/LoanTypePeriod', body, { headers: headers });
  }

  FetchApprovalLevel(){
    let body = '';
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/CommonMaster/ApprovalLevel', body, { headers: headers });
  }

}
